import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin } from '../utils/rbac';

const AdminRoute = ({ isAuthenticated, user, children }) => {
  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but user data is still loading, show loading
  if (!user) {
    return <div className="loading">Loading...</div>;
  }

  // Check if user has admin or super_admin role
  if (!isAdmin(user.user_type)) {
    // Not an admin - redirect to home
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
